module.exports = __webpack_public_path__ + "img/36.cf14078d.png";